import { FC } from 'react';
import TreeView from '../../components/TreeView';
import DragLayer from '../../components/DragLayer';
import { ItemTypes } from '../../components/DragLayer/DragItemTypes';
import { parseNodeId } from '../../utilities';
import { Content } from '@raydiant/api-client-js';
import { getPresentationData } from '../../pages/LibraryPage/utils';
import ApplicationIcon from '../../pages/LibraryPage/v2/components/ApplicationIcon';
import Text from '@raydiant/raydial/components/Text';

interface LibraryDragLayerV2Props {
  contents: Content[];
}

const LibraryDragLayerV2: FC<LibraryDragLayerV2Props> = ({ contents }) => {
  const renderContentItem = (content: Content, itemType: ItemTypes) => {
    if (itemType === ItemTypes.GridItem) {
      return (
        <div
          key={content.resourceId}
          className="h-[185px] rounded-[20px] shadow border-2 border-grey-100 flex-col justify-start items-start inline-flex cursor-pointer"
        >
          <div className="relative w-[220px] h-[125px] p-4 rounded-t-[17px] justify-between flex bg-center bg-no-repeat bg-cover">
            <div
              className="absolute inset-0 rounded-t-[17px] bg-center bg-cover bg-no-repeat"
              style={{
                backgroundImage: `url(${
                  content.presentationData.thumbnailUrl ||
                  content.presentationData.applicationThumbnailUrl
                })`,
              }}
            />
          </div>
          <div className="w-[220px] h-[60px] px-4 bg-white rounded-b-[20px] flex-col justify-center items-start gap-2.5 flex">
            <div className="self-stretch justify-start items-center gap-2 inline-flex">
              <ApplicationIcon
                url={content.presentationData.applicationIconUrl}
              />
              <div className="grow shrink basis-0 text-gray-600 break-all line-clamp-2">
                <Text variant="body">{content.name}</Text>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <TreeView.DragPreview
        key={content.resourceId}
        icon={
          <img
            alt=""
            src={content.presentationData.applicationIconUrl}
            style={{
              width: 19,
              marginRight: 1,
              marginLeft: 1,
              borderRadius: 1,
            }}
          />
        }
        label={content.name}
      />
    );
  };

  const renderDragItem = (nodeId: string, itemType: ItemTypes) => {
    const { type, id } = parseNodeId(nodeId);
    const selectedContent = contents.find(
      (content) => content.resourceType === type && content.id === id,
    );

    if (!selectedContent) return null;

    const nextContent = {
      ...selectedContent,
      presentationData: getPresentationData(selectedContent),
    };

    return renderContentItem(nextContent, itemType);
  };

  return <DragLayer renderDragItem={renderDragItem} />;
};

export default LibraryDragLayerV2;
